import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import reportWebVitals from "./reportWebVitals";
import "./shared/styles/index.css";
import "highlight.js/styles/github.css";
import { Provider } from "react-redux";
import { store } from "./services/redux/store";
import { AppLoading } from "./shared/components/AppLoading";
import "./services/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<AppLoading />}>
        <App />
      </Suspense>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
